<select [(ngModel)]="value" class="form-control" (blur)="onBlur()" (ngModelChange)="modelChange($event)">
  <option
    *ngFor="let paymentType of paymentTypes"
    [value]="paymentType.PaymentTypeId"
    [selected]="paymentType.PaymentTypeId == value ? true : null"
  >
    {{ paymentType.PaymentType }}
  </option>
</select>
